export const SCIENCE_EYEBROW = 'The science behind Vesna';
export const HEADLINE_REGULAR = '60% of lost weight can return ';
export const HEADLINE_ITALIC = 'within a year of stopping GLP-1s ';

export const MISSION_TEXT =
  'With Vesna, that changes. Now you have access to the evidence-based approach to maintaining long-term weight loss and improving overall female metabolic health.';

// `accent` keys map to theme/colors.js alpha() token names, used for each
// beat's dot indicator.
export const SCIENCE_BEATS = [
  {
    title: 'Protect what matters',
    description:
      "Strength and protein aren't extras — they're protocols, built into the journey from day one, so the pounds you lose are the ones you meant to lose.",
    accent: 'green',
    citation: 2,
  },
  {
    title: 'Nourish your mind, not just your body',
    description:
      'Our relationship with our bodies is rarely simple: your mental well-being deserves the same attention as anything physical. Vesna is the only GLP-1 tracker designed to support you through the emotional journey alongside the physical transformation.',
    accent: 'blue',
    citation: 3,
  },
  {
    title: 'Track without friction',
    description:
      'The science is clear: consistent tracking is one of the strongest predictors of keeping weight off, whether you choose to continue the medication or not. Vesna seamlessly supports your daily life so tracking becomes natural, long after motivation fades.',
    accent: 'coral',
    citation: 4,
  },
];

export const REFERENCES = [
  {
    n: 1,
    text: 'Wilding JPH, et al. "Weight Regain and Cardiometabolic Effects After Withdrawal of Semaglutide: The STEP 1 Trial Extension." Diabetes Obes Metab. 2022;24(8):1553-1564. PMID: 35441470.',
  },
  {
    n: 2,
    text: 'Look ND, et al. "Body Composition Changes During Weight Reduction with Tirzepatide in the SURMOUNT-1 Study of Adults with Obesity or Overweight." Diabetes Obes Metab. 2025. PMID: 39996356.',
  },
  {
    n: 3,
    text: 'Silva MN, et al. "Using Self-Determination Theory to Promote Physical Activity and Weight Control: A Randomized Controlled Trial in Women." J Behav Med. 2009. PMID: 20012179.',
  },
  {
    n: 4,
    text: 'Peterson ND, et al. "Dietary Self-Monitoring and Long-Term Success with Weight Management." Obesity. 2014;22(9):1962-1967. DOI: 10.1002/oby.20807 | PMID: 24931055.',
  },
];

export const CLOSING_STATEMENT = "Together, that's what it means to finally feel at home in your body.";

export const REFERENCES_DISCLAIMER = 'For informational purposes only. Not professional or medical advice. Consult your physician.';
